<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <FormInput label="Asunto" type="text" name="asunto" id="asunto" rules="required" v-model="comunicado.asunto" />
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="fecha_envio">Fecha de envio</label>
                    <ValidationProvider name="fecha_envio" rules="required" v-slot="{ errors }">
                        <datetime
                            v-model="comunicado.fecha_envio"
                            :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                            type="datetime"
                            input-id="fecha_envio"
                            value-zone="CET"
                        ></datetime>
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="nombre">Listo para enviar</label>
                    <ValidationProvider name="enviar" rules="required" v-slot="{ errors }">
                        <select id="enviar" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" v-model="comunicado.listo_para_enviar">
                            <option value="0">No</option>
                            <option value="1">Si</option>
                        </select>
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="email">Enviar a:</label>
                    <ValidationProvider name="objetivo" rules="required" v-slot="{ errors }">
                        <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="objetivo" v-model="comunicado.enviar_a">
                            <option value="1" selected>Todos los abonados + emails alternativos</option>
                            <option value="2">Todos los compradores de un evento</option>
                            <option value="3">Una lista personalizada</option>
                            <option value="4">Todos los emails recopilados de recordatorios</option>
                        </select>
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <template v-if="comunicado.enviar_a == 2">
                <div class="col-12">
                    <div class="form-group">
                        <label for="provincias">Seleccionar evento</label>
                        <ValidationProvider name="evento">
                            <multiselect 
                                placeholder="Eventos"
                                :options="eventos"
                                :value="eventos.id"
                                id="eventos"
                                label="name"
                                track-by="id"
                                v-model="comunicado.evento_id"
                            ></multiselect>
                        </ValidationProvider>
                    </div>
                </div>
            </template>

            <template v-if="comunicado.enviar_a == 3">
                <div class="col-12">
                    <div class="form-group">
                        <label for="provincias">Seleccionar base</label>
                        <ValidationProvider name="base" rules="required" v-slot="{ errors }">
                            <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="base" v-model="comunicado.base_id">
                                <template v-for="base in bases">
                                    <option :key="base.id" :value="base.id">{{ base.nombre }}</option>
                                </template>
                            </select>
                            <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
            </template>

            <div class="col-12">
                <FormInput label="Título" type="text" name="titulo" id="titulo" rules="required" v-model="comunicado.titulo" />
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="nombre">Contenido</label>
                    <ValidationProvider name="contenido" rules="required" v-slot="{ errors }">
                        <CkEditorComponent v-model="comunicado.contenido"/>
                        <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 text-right mt-3">
                <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';

export default {
    props: ['comunicado'],
    data() {
        return {
            loading: false,
            eventos: [],
            bases: [],
            conf: {}
        }
    },
    created() {
        this.getEvents();
        this.getBases();
        this.$nextTick(() => this.$refs.observer.reset());

        if(this.comunicado.listo_para_enviar) {
            this.comunicado.listo_para_enviar = 1;
        } else {
            this.comunicado.listo_para_enviar = 0;
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        manager() {
            return this.$store.getters.getFooter;
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.crearComunicado();
            }
        },
        crearComunicado() {
            this.$emit('terminado');
        },
        getEvents : function() {
            this.loading = true;
            const data = {
                filters: {
                    to_select: true,
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                this.eventos = res.data;
            }).finally(() => this.loading = false);
        },
        getBases : function() {
            this.loading = true;

            const params = {
                filters: {
                    per_page: 100,
                    page: 1,
                    search: ''
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.index'), params).then(res => {
                this.bases = res.data.data;
            }).finally(() => this.loading = false);
        },
    },
    components: {
        CkEditorComponent
    }
}
</script>
